import { useLanguage } from '../../context/LanguageContext';

const LevelCard = ({ level, onClick }) => {
    const { language } = useLanguage();
    const name = language === 'fr' ? level.libelleFr : level.libelleEn;
    const description = language === 'fr' ? level.newPageFr : level.newPageEn;

    // 1-month pricing ("À partir de...")
    const p1 = level.pricing?.find(p => p.duration === 1);
    const priceExam = p1?.priceExam != null ? parseFloat(p1.priceExam) : null;
    const priceExamCourse = p1?.priceExamCourse != null ? parseFloat(p1.priceExamCourse) : null;

    return (
        <button
            onClick={onClick}
            className="group relative bg-white dark:bg-gray-800 rounded-2xl overflow-hidden text-left transition-all duration-300 hover:scale-[1.03] hover:shadow-xl border border-gray-200 dark:border-white/10 flex flex-col"
        >
            {/* Color header */}
            <div
                className="h-3 w-full"
                style={{ backgroundColor: level.newBackgroundColor }}
            />

            <div className="p-5 flex flex-col flex-1">
                {/* Badge + labels */}
                <div className="flex items-center gap-3 mb-3">
                    <div
                        className="px-3 py-1.5 rounded-xl text-white font-extrabold text-xs shadow-sm whitespace-nowrap"
                        style={{ backgroundColor: level.newBackgroundColor }}
                    >
                        {(name || level.var).toUpperCase()}
                    </div>
                    {level.isFree && (
                        <span className="text-xs font-bold text-green-600 dark:text-green-400 bg-green-50 dark:bg-green-500/10 px-2 py-0.5 rounded-full">
                            {language === 'fr' ? 'Gratuit' : 'Free'}
                        </span>
                    )}
                    {level.isPack && (
                        <span className="text-xs font-bold text-purple-600 dark:text-purple-400 bg-purple-50 dark:bg-purple-500/10 px-2 py-0.5 rounded-full">
                            Pack
                        </span>
                    )}
                </div>

                {/* Name */}
                <h3 className="text-base font-bold text-gray-900 dark:text-white mb-2 leading-snug">
                    {name}
                </h3>

                {/* Description (truncated) */}
                {description && (
                    <p className="text-sm text-gray-500 dark:text-gray-400 line-clamp-2 mb-4 flex-1">
                        {description}
                    </p>
                )}

                {/* Price */}
                <div className="mt-auto pt-3 border-t border-gray-100 dark:border-white/5">
                    {level.isFree ? (
                        <p className="text-sm font-semibold text-green-600 dark:text-green-400">
                            {language === 'fr' ? 'Accès libre' : 'Free access'}
                        </p>
                    ) : priceExam != null ? (
                        <p className="text-sm text-gray-600 dark:text-gray-400">
                            <span className="text-[10px] font-semibold text-gray-400 dark:text-gray-500 uppercase tracking-wider">
                                {language === 'fr' ? 'À partir de ' : 'Starting at '}
                            </span>
                            <span className="font-bold text-gray-900 dark:text-white text-lg">{priceExam}$</span>
                        </p>
                    ) : null}
                </div>
            </div>

            {/* Hover arrow */}
            <div className="absolute top-5 right-5 opacity-0 group-hover:opacity-100 transition-opacity">
                <svg className="w-5 h-5 text-gray-400 dark:text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
            </div>
        </button>
    );
};

export default LevelCard;
